export default {
  components: {
    findOutMore: {
      freeDessert: 'Free dessert',
      freeDessertNextVisit: 'Free dessert on your next visit',
      iWorkHard: 'I work hard to make your time as enjoyable as possible please rate my service',
      weAlwaysWantToDoBetter: 'We always want to do better, please wait while we prepare your feedback questions',
      weJustNeedOneMinuteOfYourTime: 'We just need 1 minute of your time',
      youWillBeAskedAFewQuestions: 'You will be asked a few questions about your experience',
      yourFeedbackWillGoDirectlyToMe: 'Your feedback will go directly to me'
    }
  }
};